module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-dune-timber-kimberly-1.f06a51cc.jpg";